import { AttachmentInfo } from './attachment-info';
import { AttachmentType } from './attachment-type';

export class Attachment {
  id!: number;
  name?: string;
  attachmentName?: string;
  attachmentType!: AttachmentType;
  fileName!: string;
  fileType!: string;
  url!: string;
  file?: File;
  isSigned?: boolean;
  subAttachments?: Attachment[];
  isUploading?: boolean;
  attachmentInfo!: AttachmentInfo;
  audience?: number; 
  documentName?: string;
  createdAt!: string;
}
